export default "__VITE_ASSET__pcjn3V65__"